/**
 *  Plan getters module file
 **/

import type { PlanState } from './state.type'

// Pinia getters receive `state` as the first argument (same shape as Vuex).
export const getters = {
  getFlavour: (state: PlanState) => state.flavour,
  getMetadata: (state: PlanState) => state.metadata,
  getPlans: (state: PlanState) => state.plans,
  getPlan: (state: PlanState) => state.plan,
  getPlanFilters: (state: PlanState) => state.plan.filters,
  getAssetsMeta: (state: PlanState) => state.assets.meta,
  getAssetsCount: (state: PlanState) => state.assets.count,
  getAssetsPage: (state: PlanState) => state.assets.page,
  getAssetsCountExcluded: (state: PlanState) => state.assetsExcluded.count,
  getAssetsPageExcluded: (state: PlanState) => state.assetsExcluded.page,
  getAssetsLoaded: (state: PlanState) => !state.assets.loading,
  getNewPoiDatasetForm: (state: PlanState) => state.newPoiDatasetForm,
  getSubplanFiltersIndex: (state: PlanState) => state.activeSubPlanFiltersIndex,
  getLegendFilter: (state: PlanState) => state.plan.legend,
  getAssetsFinishedLoad: (state: PlanState) => state.assetsFinishedLoad,
  getExcludedAssetLayerAvailability: (state: PlanState) =>
    state.plan.legend.canAssetsExcludedLayerBeShown,
  getPoisBufferVisibility: (state: PlanState) =>
    state.plan.legend.poisBufferVisibility,
  getPoisVisibility: (state: PlanState) => state.plan.legend.poisVisibility,
  getPoisIconsVisibility: (state: PlanState) =>
    Boolean(state.plan.legend.poisIconsVisibility),
  getBoundariesVisibility: (state: PlanState) =>
    state.plan.legend.boundariesVisibility,
  getAssetsIdsLayerVisibility: (state: PlanState) =>
    state.plan.legend.assetsIdsLayerVisibility,
  getColorizeAssets: (state: PlanState) => state.plan.legend.colorizeAssets,
  getGeographicalDistributionRegions: (state: PlanState) =>
    state.geographicalDistributionRegions,
  getIsLoadingGeographicalDistributionRegions: (state: PlanState) =>
    state.loadingGeographicalDistributionRegions,
  getAssetsDetails: (state: PlanState) => state.assetsDetails,
  getDefaultUserCountries: (state: PlanState) => state.defaultUserCountries,
  getAssetsReadyWithAllProperties: (state: PlanState) =>
    state.assetsReadyWithAllProperties,
  getHighlightedAssets: (state: PlanState) => state.highlightedAssets,
  getForceLogout: (state: PlanState) => state.forceLogout,
  getAssetsAngleNorthMap: (state: PlanState) => state.plan.legend.angleNorthMap,
  getAudiencesQuintileVisibility: (state: PlanState) =>
    state.plan.legend.audiencesQuintile,
  getHeatmapAssetsVisibility: (state: PlanState) =>
    state.plan.legend.heatmapAssetsVisibility,
  getHeatmapAssetsType: (state: PlanState) =>
    state.plan.legend.heatmapAssetsType,
  getAssetsDigitalStaticProperties: (state: PlanState) =>
    state.assetsProperties,
  getGeoboundariesGeometriesFromCache: (state: PlanState) =>
    state.geoBoundariesGeometriesCache,
  getMyPlans: (state: PlanState) => state.plans.user,
  getPublicPlans: (state: PlanState) => state.plans.public,
  getPlansClients: (state: PlanState) => state.plans.clients,
  getIsSubscribedToPlans: (state: PlanState) => state.plans.subscribed,
  getClustersHidden: (state: PlanState) => state.plan.legend.clustersHidden,
}
